"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MyStagesDetail = void 0;
var tslib_1 = require("tslib");
var fetch_1 = require("../../../library/fetch");
var cashLoanAuth_1 = require("../../model/cashLoanAuth");
var service_1 = require("../../../library/base/service");
var MyStagesDetail = /** @class */ (function (_super) {
    (0, tslib_1.__extends)(MyStagesDetail, _super);
    function MyStagesDetail() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.name = '我的分期详情';
        _this.code = '101137';
        _this.desc = '我的分期详情';
        _this.requestParams = new cashLoanAuth_1.MyStagesDetailRequest();
        _this.method = fetch_1.Methods.POST;
        return _this;
    }
    return MyStagesDetail;
}(service_1.BaseService));
exports.MyStagesDetail = MyStagesDetail;
//# sourceMappingURL=myStagesDetail.js.map